import React, { useState } from "react";
import { Box, Button, Typography, Breadcrumbs, Link } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const RingHierarchy = ({ ring, onSelect, selectedLeaf, onReset }) => {
  const [path, setPath] = useState([ring]);

  const currentNode = path[path.length - 1];
  const hasChildren = currentNode.children && currentNode.children.length > 0;

  const handleClickNode = (node) => {
    setPath([...path, node]);
  };

  const handleClickLeaf = (node) => {
    if (onSelect) onSelect(node);
  };

  const handleBreadcrumbClick = (index) => {
    setPath(path.slice(0, index + 1));
    if (onReset) onReset();
  };

  if (!ring) return null;

  return (
    <Box sx={{ p: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 2 }}>
        {path.map((node, index) => {
          const isLast = index === path.length - 1;
          return isLast ? (
            <Typography key={node.id} color="text.primary">
              {node.name}
            </Typography>
          ) : (
            <Link
              key={node.id}
              component="button"
              variant="body1"
              underline="hover"
              onClick={() => handleBreadcrumbClick(index)}
            >
              {node.name}
            </Link>
          );
        })}
      </Breadcrumbs>

      {!selectedLeaf && (
        hasChildren ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {currentNode.children.map((child) => (
              <Button
                key={child.id}
                variant="outlined"
                fullWidth
                sx={{ justifyContent: "flex-start", textTransform: "none" }}
                onClick={() =>
                  child.children && child.children.length > 0
                    ? handleClickNode(child)
                    : handleClickLeaf(child)
                }
              >
                {child.name}
              </Button>
            ))}
          </Box>
        ) : (
          <Button
            variant="contained"
            fullWidth
            sx={{ textTransform: "none" }}
            onClick={() => handleClickLeaf(currentNode)}
          >
            {currentNode.name}
          </Button>
        )
      )}
    </Box>
  );
};

export default RingHierarchy;
